var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 25 24",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.966 11.293c1.133-1.133 3.109-1.133 4.242 0l.707.707 1.414-1.414-.707-.707a4.97 4.97 0 0 0-3.535-1.465 4.97 4.97 0 0 0-3.535 1.465l-2.122 2.12a5.01 5.01 0 0 0 0 7.072 4.98 4.98 0 0 0 3.535 1.462A4.98 4.98 0 0 0 12.5 19.07l.707-.707-1.414-1.414-.707.707a3.007 3.007 0 0 1-4.243 0 3.005 3.005 0 0 1 0-4.243z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12.5 4.929-.707.707 1.414 1.414.707-.707a3.007 3.007 0 0 1 4.243 0 3.005 3.005 0 0 1 0 4.243l-2.122 2.121c-1.133 1.133-3.11 1.133-4.242 0L11.086 12l-1.414 1.414.707.707a4.97 4.97 0 0 0 3.535 1.465 4.97 4.97 0 0 0 3.535-1.465L19.57 12a5.01 5.01 0 0 0 0-7.071 5.006 5.006 0 0 0-7.071 0"
  })));
};
export default SvgLink;